import { CommerceNoticeStatusCode } from '@gooduncles/gu-app-schema';

export const commerceNoticeStatusLabel: Record<CommerceNoticeStatusCode, string> = {
  [CommerceNoticeStatusCode.DRAFT]: '임시저장',
  [CommerceNoticeStatusCode.PUBLISHED]: '게시됨',
  [CommerceNoticeStatusCode.HIDDEN]: '숨김',
};

export const commerceNoticeStatusColor: Record<CommerceNoticeStatusCode, string> = {
  [CommerceNoticeStatusCode.DRAFT]: 'default',
  [CommerceNoticeStatusCode.PUBLISHED]: 'success',
  [CommerceNoticeStatusCode.HIDDEN]: 'warning',
};

export const COMMERCE_NOTICE_COLLECTION = 'commerceNotice';
